import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const points = [
  'garantie_point1',
  'garantie_point2',
  'garantie_point3',
  'garantie_point4',
];

export default function Garantie() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="garantie" className="bg-slate-primary py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl mb-6 md:mb-8 text-center">
            {t('garantie_h2')}
          </h2>

          <p className="text-white/80 text-base md:text-lg leading-relaxed text-center max-w-3xl mx-auto mb-10 md:mb-12">
            {t('garantie_text')}
          </p>

          {/* Image */}
          <div
            className={`rounded-xl overflow-hidden mb-10 md:mb-12 transition-all duration-1000 delay-100 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20roofer%20on%20a%20completed%20new%20roof%20giving%20thumbs%20up%20to%20the%20camera%2C%20wearing%20safety%20helmet%20and%20harness%2C%20Quebec%20house%20roof%20with%20pristine%20asphalt%20shingles%2C%20blue%20sky%20background%2C%20confident%20worker%20portrait%2C%20warm%20natural%20light%2C%20documentary%20photography%20style%2C%20no%20text%20visible&width=1000&height=400&seq=ref-gar1&orientation=landscape"
              alt="Couvreur professionnel satisfait sur une toiture neuve récemment réfectée à Lévis par couvreur RBQ"
              className="w-full h-48 md:h-56 object-cover object-top"
              loading="lazy"
              width="1000"
              height="400"
              width="1000"
              height="400"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {points.map((key, idx) => (
              <div
                key={idx}
                className={`flex items-start gap-4 bg-white/5 border border-white/10 rounded-lg p-4 md:p-5 transition-all duration-1000 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: `${idx * 150}ms` }}
              >
                <span className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-copper/20">
                  <i className="ri-check-line text-copper" />
                </span>
                <p className="text-white/90 text-sm md:text-base font-medium">
                  {t(key)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}